import ClearIcon from '@material-ui/icons/HighlightOff';
import {Box, Button, Grid, IconButton, Typography} from '@material-ui/core';
import {TextValidator} from 'react-material-ui-form-validator';
import {FOOD_TYPES} from "../../../../utilities/constants";
import {useStyles} from './styles';

const Foods = ({foods, type, addFood, updateFood, removeFood}) => {
  const classes = useStyles();

  const handleFoodChange = (index, value) => {
    const newFoods = Array.isArray(foods) ? [...foods] : []; // Ensure it's an array
    newFoods[index] = value;
    updateFood(newFoods);
  };

  const addNewFood = () => {
    addFood(type);
  };

  const renderTitle = () => {
    switch (type) {
      case FOOD_TYPES.FOOD_TO_EAT:
        return <Typography variant="subtitle1"><strong>Food To Eat</strong></Typography>
      case FOOD_TYPES.FOOD_TO_AVOID:
        return <Typography variant="subtitle1"><strong>Food To Avoid</strong></Typography>
    }
  };

  return (
    <Box style={{marginTop: 16}}>
      <Box display="flex" alignContent="center" justifyContent="space-between">
        {renderTitle()}
        {/* Add Food Button */}
        <Button variant="contained" color="primary" onClick={addNewFood} className={classes.addMedicineButton}>
          Add Food
        </Button>
      </Box>
      {foods?.map((medicine, index) => (
        <Box key={`${type}-${index}`} display="flex" alignItems="center" style={{marginTop: 16}}>
          <Grid container className={classes.medicineDetailsContainer}>
            <Grid item xs={12}>
              <TextValidator
                label="Food"
                variant='outlined'
                fullWidth
                size='small'
                value={foods[index]}
                onChange={(e) => handleFoodChange(index, e.target.value)}
              />
            </Grid>
          </Grid>

          {/* Remove Food Button */}
          {foods?.length > 1 && (
            <IconButton variant="outlined" color="secondary" onClick={() => removeFood(index)} style={{marginLeft: 8}}>
              <ClearIcon/>
            </IconButton>
          )}
        </Box>
      ))}
    </Box>
  )
};

export default Foods;